import type { ComponentType } from '../../enums';
import { ActionType } from '../../enums';

export interface CreateSortOpenEventPayloadOptions {
  componentType: ComponentType;
  componentVariant: string;
  pageType: string;
}

export interface CreateSortOpenEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    component_variant: string;
    page_type: string;
  };
}

export const createSortOpenEventPayload = ({
  componentType,
  componentVariant,
  pageType,
}: CreateSortOpenEventPayloadOptions): CreateSortOpenEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.OPEN,
      page_type: pageType,
      component_type: componentType,
      component_variant: componentVariant,
    },
  };
};
